import {ComplexTextFont} from 'common/src/modules/complexText/complexText.types';
import {DPMeta} from 'common/src/modules/dynamicParameters/dynamicParameters.types';

const fontsTag = document.createElement('style');
document.head.appendChild(fontsTag);

const loadedFonts = new Set<string>();

export default function loadMetaFonts(data: {meta: DPMeta}[]): void {
  const fontsToLoad: Map<string, ComplexTextFont> = new Map();

  data.forEach(({meta}) => {
    meta.comps.forEach((comp) => {
      comp.layers.forEach(({fontFileUrl, textMetadata}) => {
        if (!textMetadata) return;

        if (textMetadata.txtObj?.fonts) {
          textMetadata.txtObj.fonts.forEach((font) => {
            fontsToLoad.set(font.family, {
              url: font.url,
              weight: font.weight,
              italic: font.italic,
              family: font.family,
            });
          });
        } else if (fontFileUrl) {
          fontsToLoad.set(textMetadata.fontName, {
            url: fontFileUrl,
            weight: textMetadata.weight.toString(),
            italic: textMetadata.isItalic,
            family: textMetadata.fontName,
          });
        }
      });
    });
  });

  for (const [fontName, {url, weight, italic}] of fontsToLoad.entries()) {
    const fontKey = `${fontName}:${weight}`;

    if (loadedFonts.has(fontKey)) continue;

    loadedFonts.add(fontKey);
    fontsTag.innerHTML += `@font-face {font-family: ${fontName};src: url('${url}') format('woff');font-weight: ${weight};font-style: ${
      italic ? 'italic' : 'normal'
    };}`;
  }
}
